import { roleService } from "../services/role.service";

export const role = {
  namespaced: true,
  state: {
    roleList: []
  },
  actions: {
    getRoleList({ commit }) {
      roleService.getAllRole().then(roles => {
        roles = roles.sort(function(a, b){
            if(a.roleName.toLowerCase() < b.roleName.toLowerCase()) return -1;
            if(a.roleName.toLowerCase() > b.roleName.toLowerCase()) return 1;
            return 0;
        });
        commit("setRoleList", roles);
      })

    }
  },
  mutations: {
    setRoleList(state, roleList) {
      state.roleList = roleList;
    }
  }
};
